export const AUTH_SESSION_EXPIRED_EVENT = 'auth-session-expired';
export const APP_DATA_MUTATED_EVENT = 'app-data-mutated';
export const ORGANIZATION_FROZEN_EVENT = 'organization-frozen';
export const FORBIDDEN_ACCESS_EVENT = 'forbidden-access';
